/// <amd-module name="Test/common-util/TelemetryConstants" />
//List of contexts
export const buildContext: string = "Build";
export const releaseContext: string = "Release";

// TestManagement area name
export const areaTestManagement: string = "TestManagement";

// Common events
export const inProgress: string = "InProgress";
export const completed: string = "Completed";
export const others: string = "Others";
export const totalTests: string = "TotalTests";
export const failedTests: string = "FailedTests";
export const passedTests: string = "PassedTests";
export const totalTestsExists: string = "TotalTestsExists";
export const failedTestsExists: string = "FailedTestsExists";
export const eventClicked: string = "Clicked";
export const workflow: string = "Workflow";
export const id: string = "Id";

// Actions

// List of feature names
// Make sure that the names are same as in server project, if telemetry is being captured from the server as well
export const featureTestTab_SignalRRefreshed: string = "NewTestTab_SignalRRefreshed";
export const featureTimelineInBuild: string = "BuildTimeline";
export const featureTestTab_Filter = "NewTestTab_Filter";
export const featureTestTab_FilterButtonClicked: string = "NewTestTab_FilterButtonClicked";
export const featureTestTab_BuildLinkClicked: string = "NewTestTab_BuildLinkClicked";
export const featureTestTab_ReleaseLinkClicked: string = "NewTestTab_ReleaseLinkClicked";
export const featureTestTab_TestRowVisited: string = "TestTab_TestRowSingleVisited";
export const featureTestTab_DetailsPanelClosed: string = "TestTab_DetailsPaneClosed";
export const featureTestTab_DetailsPanelFullView: string = "TestTab_DetailsPaneFullView";
export const featureTestTab_DetailsDirectLink = "TestTab_DetailsDirectLink";
export const featureTestTab_ErrorInSummaryDataProvider: string = "TestTab_ErrorInSummaryDataProvider";
export const featureTestTab_ErrorInResultsGridDataProvider: string = "TestTab_ErrorInResultsGridDataProvider";
export const featureTestTabSignalR: string = "NewTestTab_SignalR";
export const featureTestTab_ColumnsChanged: string = "NewTestTab_ColumnsChanged";
export const featureTestTab_DurationSorted: string = "NewTestTab_DurationSorted";
export const featureTestTab_ShowMoreTestResultsAfterFilter: string = "NewTestTab_ShowMoreTestResultsAfterFilter";
export const featureTestTab_InProgressViewRefreshed: string = "NewTestTab_InProgressViewRefreshed";
export const featureTestTab_SummaryExpandCollapseClicked: string = "NewTestTab_SummaryExpandCollapseClicked";
export const featureTestTab_GroupByClicked: string = "NewTestTab_GroupByClicked";
export const featureTestTab_MarkUnMarkFlakyClicked: string = "NewTestTab_MarkUnMarkFlakyClicked";
export const featureTestTab_FlakyCanceledClicked: string = "NewTestTab__FlakyCanceledClicked";
export const featureTestTab_AssociateToTestCaseClicked: string = "NewTestTab_AssociateToTestCaseClicked";
export const featureTestTab_AssociateToTestCaseDismissClicked: string = "NewTestTab_AssociateToTestCaseDismissClicked";
export const featureTestTab_AssociateToTestCaseError: string = "NewTestTab_AssociateToTestCaseError";
export const featureTestTab_TestTabClicked: string = "NewTestTab_TestTabClicked";
export const featureTestTab_TestTabWithOnlyNotReportedTests: string = "NewTestTab_TestTabWithOnlyNotReportedTests";
export const featureTestTab_summaryInBuildTimelineRendered: string = "NewTestTab_SummaryInBuildTimelineRendered";
export const featureResultsListView_SelectionOfHierarchicalResults = "ResultsListView_SelectionOfHierarchicalResults";
export const featureAnalyticsInProductLink_PassRate_SummarySection = "AnalyticsInProductLink_PassRate_SummarySection";
export const featureAnalyticsInProductLink_UniqueFailingTests_TestTab = "AnalyticsInProductLink_UniqueFailingTests_TestTab";
export const featureTestTab_TestInAzurePipelineFwLinkClicked = "NewTestTab_TestInAzurePipelineFwLinkClicked";

//Test Project Settings Telemetry
export const featureFlakyTestProjectSettings: string = "FlakyTestProjectSettingsUpdate";
export const featureFlakyDialogBoxCancellation: string = "FlakyTestSettingsUpdateCancellation";

// Telemetry property names.
export const errorOccurredDuringSignalRConnection: string = "NewTestTab_ErrorOccurredDuringSignalRConnection";

// New Test Logging Settings telemetry
export const featureNewTestLoggingSettings: string = "NewTestLoggingSettingsUpdate";